const INITIAL_STATE = {
    searchText: '',
    filter: [],
    todosServicos: [],
    menuItems:null,
    launchSagService: null,
    launchExternalLink: null,
    servicos:null,
    servicosRecomendados: null,
    banners:null,
    infoDevice: null,
    deviceRegistered: false,
    open: false,
    routes: [],
    gestaoIndisponivel: false,
    servicoSelecionado:null,
    solicitandoMenu: false,//TODO Remover
    tituloPagina: "Meu INSS",
    errorServicosHome: false,
    dicionarioPaths: {},//TODO Remover
    padroesDePath: new Set(),
    gravaBreadcrumb: false,//TODO Remover
    isMenuActive: false,
    launchSagServiceOrigemClick: "",
    msgAcessoProcurador: "",
    mensagemErro: null,
	loadingBanners: false,
    loadingServicosSemSenha: false,
    breadcrumb: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case 'SET_IS_MENU_ACTIVE':
            return {...state, isMenuActive: action.payload}
        case 'APP_BUSCA_ALTERADA':
            return {...state, searchText: action.payload};
        case 'APP_ITENS_MENU_RECEBIDOS':
            return {...state, menuItems: action.payload, gestaoIndisponivel: false, solicitandoMenu: false};

        case 'APP_SET_SOLICITANDO_MENU':
            return {...state, solicitandoMenu: action.payload};
        
        case 'APP_GESTAO_INDISPONIVEL':
            return {...state, gestaoIndisponivel: action.payload, solicitandoMenu: false}

        case 'APP_MENU_SET_ITENS_MENU':
            return {...state, itensMenu: action.payload, gestaoIndisponivel: false, solicitandoMenu: false};
            
        case 'APP_SOLICITADO_CATALOGO_SAG':
            return {...state, loadingSagServices: true};

        case 'APP_CATALOGO_SAG_RECEBIDO':
            return {...state,  sagServices: action.payload, loadingSagServices: false};

        case 'APP_ERRO_SOLICITACAO_SAG':
            return {...state, sagServices: 'erro', loadingSagServices: false}    
       
        case 'APP_REQUEST_LAUNCH_SAG_SERVICE':
            return {...state, launchSagService: action.payload?.sagService, launchSagServiceOrigemClick: action.payload?.origemClick}

        case 'APP_LAUNCH_SAG_SERVICE_DISMISSED':
            return {...state, launchSagService: null, launchSagServiceOrigemClick: null}

        case 'APP_REQUEST_LAUNCH_EXTERNAL_LINK':
            return {...state, launchExternalLink: action.payload}

        case 'APP_LAUNCH_EXTERNAL_DISMISSED':
            return {...state, launchExternalLink: null}
            
        case 'APP_SOLICITADO_CATALOGO_GESTAO':
            return { ...state, loadingSagServices: true }

        case 'APP_ITENS_SERVICOS_RECEBIDOS': 
            return { ...state, servicosPerfis: action.payload };        

        case 'APP_ITENS_SERVICOS_RECOMENDADOS_RECEBICOS': {
            return { ...state, servicosRecomendados: action.payload, errorServicosHome: false, gestaoIndisponivel: false, loadingServicosRecomendados: false };
        }

        case 'APP_ITENS_SERVICOS_RECOMENDADOS_ERRO': {
            return { ...state, servicosRecomendados: action.payload, errorServicosHome: true, loadingServicosRecomendados: false };
        }

        case 'APP_PARAMETROS_RECEBICOS': {
            return { ...state, parametros: action.payload};
        }

        case 'APP_ERRO_SOLICITACAO_GESTAO':
            return { ...state, sagServices: 'erro', loadingSagServices: false }

        case 'APP_ITENS_BANNERS_RECEBIDOS':
            return { ...state, banners: action.payload, erroBanners: false, loadingBanners: false }; 

        case 'APP_ITENS_SERVICOS_SEM_SENHA_RECEBIDOS':
            return { ...state, servicosSemSenha: action.payload, erroServicosSemSenha: false, loadingServicosSemSenha: false};            

        case 'APP_ERRO_SOLICITACAO_GESTAO_BANNER':
            return { ...state, banners: null, erroBanners: true, loadingBanners: false }

        case 'APP_ERRO_SOLICITACAO_SERVICOS_SEM_SENHA':
            return { ...state, servicosSemSenha: action.payload, erroServicosSemSenha: true, loadingServicosSemSenha: false }

        case 'APP_DIALOG_DEVICE_REGISTER':
            return { ...state, open: action.payload }

        case 'APP_DEVICE_GET_INFO':
            return { ...state, deviceRegistered: false, open: false, infoDevice: { situacao: action.payload.situacao, autorizacao: action.payload.autorizacao }}

        case 'APP_DEVICE_REGISTERED':            
            return { ...state, deviceRegistered: true, open: false, infoDevice: { ...state.infoDevice, autorizacao: action.payload.autorizacao } }

        case 'APP_NOTIFICATION_REGISTERED':
            return { ...state, infoDevice: { ...state.infoDevice, autorizacao: action.payload.autorizacao } }

        case 'APP_DEVICE_REGISTERED_ERROR':
            return { ...state, open: false, deviceRegistered: false }    
        
        case 'APP_SERVICO_SELECIONADO':
            return { ...state, servicoSelecionado: action.payload }
        
        case 'APP_ATUALIZAR_TITULO_PAGINA':
            return { ...state, tituloPagina: action.payload }

        case 'APP_ATUALIZAR_MSG_ACESSO_PROCURADOR':
            return { ...state, msgAcessoProcurador: action.payload }
        
         case 'APP_SEARCH_TEXT':
            return { ...state, searchText: action.payload }
        
         case 'APP_SEARCH_FILTER':
            return { ...state, filter: action.payload }
    
        
         case 'APP_SEARCH_TODOS':
            return { ...state, todosServicos: action.payload }
        
        case 'APP_ADD_TO_DICIONARIO_PATH':
            const { padroesDePath } = state;
            if(action.payload.pathname.includes(":")){
                padroesDePath.add(action.payload.pathname);
            }
            return {...state, padroesDePath, dicionarioPaths: {...state.dicionarioPaths, [action.payload.pathname]: action.payload.title }}
        case 'APP_GRAVA_BREADCRUMB': 
            return {...state, gravaBreadcrumb: action.payload}
        case 'APP_MENSAGEM_ERRO':
            return {...state, mensagemErro: action.payload}
        case 'APP_REQUEST_BANNERS':
            return { ...state, loadingBanners: true };
        case 'APP_REQUEST_SERVICOS_SEM_SENHA':
            return { ...state, loadingServicosSemSenha: true}; 
        case 'APP_REQUEST_SERVICOS_RECOMENDADOS':
            return {...state, loadingServicosRecomendados: true}
        case 'APP_BREADCRUMB':
            let caminho = action.payload.caminho || state.breadcrumb?.caminho || null;
            let parent = action.payload.parent || state.breadcrumb?.parent || null;
            let enabled = action.payload.enabled ?? true;
            return {...state, breadcrumb: {parent, caminho, enabled}}
         case 'APP_RESET_BREADCRUMB':
            return {...state, breadcrumb: {}}
        default:
            return state;
    }
}
